
const CANCELLABLE_CLASS = 'link_undo';

const DEFAULT_NOTIFICATION_OPTIONS = {
    cancellationCallback: () => {},
    timeoutCallback: () => {},
    cancellationText: () => (Hop.message ? Hop.message('general.cancel') : 'Cancel'),
};

export class CancellableNotificationService {
    constructor(service) {
        this.notificationService = service;
        this.defaultNotificationOptions = Object.assign(this.notificationService.getDefaultNotificationOptions(), DEFAULT_NOTIFICATION_OPTIONS);
        this.notificationService.setUpNotificationContainer();
        this.undo = this.undo.bind(this);
    }

    push(
        message,
        {
            level = this.notificationService.getDefaultNotificationOptions().level,
            duration = this.notificationService.getDefaultNotificationOptions().duration,
            closable = this.notificationService.getDefaultNotificationOptions().closable,
            cancellationCallback = DEFAULT_NOTIFICATION_OPTIONS.cancellationCallback,
            timeoutCallback = DEFAULT_NOTIFICATION_OPTIONS.timeoutCallback,
            cancellationText = DEFAULT_NOTIFICATION_OPTIONS.cancellationText(),
        } = this.defaultNotificationOptions,
    ) {
        this.id = this.notificationService.generateNewNotificationId();
        this.cancellationCallback = cancellationCallback;
        this.timeoutCallback = timeoutCallback;

        const contentBuilder = this.contentBuilder(message, level, closable, cancellationText);
        const notificationContent = this.notificationService.getNotificationContentBuilder(contentBuilder);

        this.notificationService.display(notificationContent);
        this.timeout = this.setUpLifeDuration(duration);
        this.undoElement = this.notificationService.container.querySelector(`.${CANCELLABLE_CLASS}`);
        this.bindListeners();

        return {
            id: this.id,
            message,
            level,
            duration,
            closable,
        };
    }

    contentBuilder(message, level, closable, cancellationText) {
        const cancellableNotificationPart = `<strong class='${CANCELLABLE_CLASS}'>${cancellationText}</strong>`;
        return {message, level, id: this.id, closable, htmlExtension: cancellableNotificationPart};
    }

    undo(event) {
        clearTimeout(this.timeout);
        this.deleteNotificationElement();

        if (event.type === 'blur') {
            this.timeoutCallback();
        } else {
            this.cancellationCallback();
        }
    }

    setUpLifeDuration(duration) {
        return setTimeout(() => {
            this.deleteNotificationElement();
            this.timeoutCallback();
        }, duration);
    }

    deleteNotificationElement() {
        this.notificationService.deleteNotificationElement(this.id);
        this.unbindListeners();
    }

    bindListeners() {
        this.undoElement.addEventListener('click', this.undo);
        window.addEventListener('blur', this.undo);
    }

    unbindListeners() {
        this.undoElement.removeEventListener('click', this.undo);
        window.removeEventListener('blur', this.undo);
    }

    clear() {
        this.notificationService.container.innerHTML = '';
    }
}
